import { Channel } from '../../domain';
import { ExtendedChannel } from '../types';

const byChannelId =
  (channelIds: Set<Channel['id']>) =>
  ({ id }: ExtendedChannel) =>
    channelIds.has(id);

export const filterByChannelIds = (channels: ExtendedChannel[], channelIds: Set<Channel['id']>) =>
  channels.filter(byChannelId(channelIds));
